import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchWorkkardFieldsRequest, clearWorkkardFields } from '../store/workkardFormSlice';
import { selectWorkkardFields, selectAreFieldsLoading, selectFieldsError } from '../store/selectors';

export function useWorkkardFields(selectedTemplateShortName, renderType = 'new') {
  const dispatch = useDispatch();
  const workkardFields = useSelector(selectWorkkardFields);
  const areFieldsLoading = useSelector(selectAreFieldsLoading);
  const fieldsError = useSelector(selectFieldsError);

  useEffect(() => {
    if (!selectedTemplateShortName) {
      dispatch(clearWorkkardFields());
      return;
    }
    dispatch(fetchWorkkardFieldsRequest({ short_name: selectedTemplateShortName, render_type: renderType }));
  }, [selectedTemplateShortName, renderType, dispatch]);

  return { workkardFields, areFieldsLoading, fieldsError };
}
